<template>
  <div>
    <div class="home-container">
      <ContractsChartTile :datas="[]" :year="year"/>
      <RfaChartTile v-if="declarationYearPeriod"
                    :p-datas="rfa.year.datas"
                    :p-loading="rfa.year.loading"
                    :period="declarationYearPeriod"
                    :detailed-periods="detailedPeriods"
                    :concept="rfaTileConcept"
                    @concept-change="rfaTileConcept = $event"
      />
      <RfaChartTile v-if="advancePeriod"
                    :p-datas="rfa.advance.datas"
                    :p-loading="rfa.advance.loading"
                    :period="advancePeriod"
                    @period-change="advancePeriod=$event"
                    :detailed-periods="detailedPeriods"
      />
      <EllisphereAlertsTile/>
      <StatsRecapTile v-if="statPeriod" :period="statPeriod" @period-change="statPeriod=$event"
                      :detailed-periods="detailedPeriods"/>

      <SuiviGrfaTile v-if="declarationYearPeriod"
                     :p-datas="rfa.year.datas"
                     :p-loading="rfa.year.loading"
                     :period="declarationYearPeriod"
                     :detailed-periods="detailedPeriods"
                     :concept="rfaTileConcept"
                     @concept-change="rfaTileConcept = $event"
      />
      <SuiviGrfaTile v-if="advancePeriod"
                     :p-datas="rfa.advance.datas"
                     :p-loading="rfa.advance.loading"
                     :period="advancePeriod"
                     @period-change="advancePeriod=$event"
                     :detailed-periods="detailedPeriods"
      />
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import StatsRecapTile from "@/components/Dashboards/StatsRecapTile.vue";
import EllisphereAlertsTile from "@/components/Dashboards/EllisphereAlertsTile.vue";
import RfaChartTile from "@/components/Dashboards/RfaChartTile.vue";
import ContractsChartTile from "@/components/Dashboards/ContractsChartTile.vue";
import SuiviGrfaTile from "@/components/DashboardGRFA/SuiviGrfaTile.vue";
import {getSuiviGrfa} from "@/utils/dashboardGrfa";
import store from "@/store/dashboards";

export default {
  name: "Home",
  components: {SuiviGrfaTile, ContractsChartTile, RfaChartTile, EllisphereAlertsTile, StatsRecapTile},
  props: ["year", "detailedPeriods"],
  data() {
    return {
      rfa: {
        year: {
          datas: [],
          loading: 0
        },
        advance: {
          datas: [],
          loading: 0
        }
      },
      rfaTileConcept: 1,
      advancePeriod: null,
      statPeriod: null,
      store
    }
  },
  methods: {
    initRfaDatas(type = "year") {
      if (type === "year" && !this.declarationYearPeriod) return;
      else if (type === "advance" && !this.advancePeriod) return;

      this.rfa[type].loading = 1;
      getSuiviGrfa(type === "year" ? this.declarationYearPeriod.id : this.advancePeriod.id, type === "year" ? this.rfaTileConcept : 1, this.storeGlobalView).then(res => {
        this.rfa[type].datas = res;
        this.rfa[type].loading = 0;
      })
    },
    syncAdvancePeriod() {
      let period = null;
      this.advancePeriod = null;
      const now = dayjs();

      if (this.year < now.year()) {
        // C'est l'année précédente. On retourne le dernier acompte : T3
        period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year);
      } else if (this.year > now.year()) {
        // Fin 2025 sélection contrats 2026. On affiche le T3 2025
        period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year - 1);
      } else if (this.year == now.year()) {
        let t2Treshold = dayjs().month(6).date(15);
        let t3Treshold = dayjs().month(9).date(15);

        if (now.isAfter(t3Treshold)) {
          // On est après le 15 octobre, T3 disponibles
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 10 && dp.year == this.year);
        } else if (now.isAfter(t2Treshold)) {
          // On est après le 15 juillet, T2 disponibles
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 7 && dp.year == this.year);
        } else {
          // On affiche T1 par défaut
          period = this.detailedPeriods.find(dp => dp.declarationType == 2 && dp.rfaPaymentFrequency == 4 && dp.month == 4 && dp.year == this.year);
        }
      }

      if (period) this.advancePeriod = period;
    },
    syncStatPeriod() {
      this.statPeriod = null;
      if (!this.detailedPeriods || !this.detailedPeriods.length) return;

      let refDate = dayjs().subtract(10, "days");

      let year = refDate.year();
      let month = refDate.month(); // on laisse indexé sur 0, car en février par ex. on veut la stat janvier

      if (month === 0) {
        month = 12;
        year -= 1;
      }

      this.statPeriod = this.detailedPeriods.find(dp => dp.declarationType == 1 && dp.month == month && dp.year == year);
    },
  },
  mounted() {
  },
  watch: {
    storeGlobalView() {
      this.initRfaDatas("year");
      this.initRfaDatas("advance");
    },
    declarationYearPeriod() {
      this.initRfaDatas("year");
    },
    advancePeriod() {
      this.initRfaDatas("advance");
    },
    rfaTileConcept() {
      this.initRfaDatas("year");
    },
    year() {
      this.syncAdvancePeriod();
      this.syncStatPeriod();
    },
    detailedPeriods() {
      this.syncAdvancePeriod();
      this.syncStatPeriod();
    }
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    },
    currentYearPeriod() {
      if (!this.detailedPeriods || !this.detailedPeriods.length) return null;
      return this.detailedPeriods.find(dp => dp.declarationType == 3 && dp.year == this.year);
    },
    declarationYearPeriod() {
      // On récupère la déclaration annuelle N-1
      if (!this.detailedPeriods || !this.detailedPeriods.length) return null;
      return this.detailedPeriods.find(dp => dp.declarationType == 3 && dp.year == this.year - 1);
    },
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.home-container h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}
</style>

<style>
.home-container .white-box {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/RFA/DashboardGRFA/Home.vue